import { Output, EventEmitter } from '@angular/core';
import { WorkFieldInputChangeEvent } from '../../../events/work-field-input-change-event';
import { E5coreUiWorkFieldTypeComponentBase } from '../../../components/e5core-ui-work-field/e5core-ui-work-field-type-component-base';

export class E5coreUiWorkFieldTypeTextBaseComponent extends E5coreUiWorkFieldTypeComponentBase {

  @Output() valueChange = new EventEmitter<WorkFieldInputChangeEvent>() ;

  changeValue($event: string) {
    this.valueChange.emit({$event: $event, value: $event}) ;
  }
}
